import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import Editor from 'components/editor'
import { Button, Checkbox, FormControlLabel, Stack } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
const CreateModal = ({ handleRefresh, category }) => {
  const uploadImage = useUploadImage()

  const [agency] = useAgencyInfo()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [description, setDescription] = useState('')
  const { page_id } = useParams()
  // const [category, setCategory] = useState([])

  // const getCategories = async () => {
  //   const { response } = await AppService.onboardlistcategory.get({
  //     toaster: false,
  //   })
  //   if (response) {
  //     setCategory(response.data)
  //   } else {
  //     setCategory([])
  //   }
  // }

  console.log(page_id, 'params1212')
  const handleModal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)
    // let image_response;
    // image_response = await uploadImage({
    //   file: e.target?.image?.files?.[0],
    //   desiredPath: `app/logo/image`,
    // })
    let image_response
    if (e.target?.image?.files?.[0]) {
      const { response } = await uploadImage({
        file: e.target?.image?.files?.[0],
        desiredPath: `app/logo/image`,
      })
      if (response) {
        image_response = response.data
      }
    }

    const payload = {
      name: e.target.name.value,
      description, // Using state for CKEditor content
      image: image_response,
      video_path: e.target.video_path.value,
      page_path: e.target.page_path.value,
      status: e.target.status.value,
      points: e.target.points.value,
      category_id: page_id,
      status: e.target.status.value,
      custom_buttons: e.target.custom_buttons.checked,
      type: e.target.type.value,
    }

    const { response } = await AppService.onboarding_list.create({ payload })

    if (response) {
      setProcessing(false)
      closeAddProduct()
      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612, // Increased width for better spacing
    maxHeight: '90vh',
    overflowY: 'auto', // Enables scrolling when needed
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>

      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Onboarding List
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography
                variant="button"
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <p>Page Path</p>

                <FormControlLabel
                  control={<Checkbox name="custom_buttons" />}
                  label="Custom Buttons"
                />
              </MDTypography>
              <MDInput label="Page Path" name="page_path" fullWidth required />
            </MDBox>

            {/* <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput select name="type" fullWidth required SelectProps={{ native: true }}>
                <option value="location">Location</option>
                <option value="agency">Agency</option>
                <option value="levelupmarketplace">LevelUpMarketplace</option>
              </MDInput>
            </MDBox> */}


            {/* <MDBox mb={2}>
              <MDTypography variant="button">Category</MDTypography>
              <MDInput select name="category_id" fullWidth required SelectProps={{ native: true }}>
                <option value="">Select a category</option>
                {category.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </MDInput>
            </MDBox> */}

            <MDBox mb={2}>
              <MDTypography variant="button">Points</MDTypography>
              <MDInput label="Points" name="points" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Video Path</MDTypography>
              <MDInput label="Video Path" name="video_path" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Status</MDTypography>
              <MDInput select name="status" fullWidth required SelectProps={{ native: true }}
                defaultValue="Publish"
              >
                <option value="Publish">Publish</option>
                <option value="Draft">Draft</option>
              </MDInput>
            </MDBox>

            <MDBox mb={2}>
                                      <MDTypography variant="button">Type</MDTypography>
                                      <MDInput select name="type" fullWidth required SelectProps={{ native: true }}
                                        defaultValue="agency"
                                      >
                                        <option value="agency">Agency</option>
                                        <option value="location">Location</option>
                                      </MDInput>
                                    </MDBox>
           
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Image +
                <input hidden name="image" type="file" />
              </Button>
            </Stack>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
